"use strict";
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabularSampleSet = exports.TabularFieldSet = exports.ParcelMinimal = exports.FarmMinimal = exports.SampleTabular = exports.FieldTabular = exports.FarmReport = void 0;
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const GeoEntities_1 = require("./GeoEntities");
const GeoEntities_2 = require("./GeoEntities");
const Crop_1 = __importDefault(require("./Crop"));
const Client_1 = __importDefault(require("./Client"));
const Sample_1 = require("./Sample");
const project_1 = require("@becrop/components/Results/Abstract/Interfaces/project");
class FarmReport {
    constructor(obj) {
        this.bioMetrics = obj.bioMetrics || new Array();
    }
    get bioMetricsByFarmCategories() {
        var _a;
        const categories = [];
        (_a = this.bioMetrics) === null || _a === void 0 ? void 0 : _a.forEach((bm) => {
            const catIx = categories.findIndex((afcm) => afcm.name === bm.category);
            (catIx !== -1) ?
                categories[catIx].metrics.push(bm) :
                categories.push(new project_1.AreaFarmCategoryMetrics(bm.category, [bm]));
        });
        return categories;
    }
    get bioMetricsByFarmCategoriesIgnoringAggregated() {
        var _a;
        const categories = [];
        (_a = this.bioMetrics) === null || _a === void 0 ? void 0 : _a.filter((me) => !me.code_name.startsWith('SO')).forEach((bm) => {
            const catIx = categories.findIndex((afcm) => afcm.name === bm.category);
            (catIx !== -1) ?
                categories[catIx].metrics.push(bm) :
                categories.push(new project_1.AreaFarmCategoryMetrics(bm.category, [bm]));
        });
        return categories;
    }
    findMetric(code) {
        var _a;
        return (_a = this.bioMetrics) === null || _a === void 0 ? void 0 : _a.find((m) => m.code_name === code);
    }
}
exports.FarmReport = FarmReport;
class FieldTabular {
    constructor(obj) {
        this.name = obj.name || '#FieldTabular',
            this.id = obj.id || -1,
            this.geodata = obj.geodata || '-',
            this.crop = obj.crop || new Crop_1.default({}),
            this.acreage = obj.acreage || new Acreage_1.default(-1, '');
        this.farm = obj.farm || new FarmMinimal({ name: '#FarmMinimal', id: -1 });
        this.client = obj.client || new Client_1.default({});
        this.results = obj.results || new FarmReport({});
        this.addProperties();
    }
    findMetric(code) {
        var _a;
        return (_a = this.results) === null || _a === void 0 ? void 0 : _a.findMetric(code);
    }
    addProperties() {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.bioMetrics) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            (_d = (_c = this.results) === null || _c === void 0 ? void 0 : _c.bioMetrics) === null || _d === void 0 ? void 0 : _d.forEach((b) => {
                this[b.code_name] = b.scoreBC.value;
            });
        }
    }
    get hasMetrics() {
        var _a, _b;
        return ((_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.bioMetrics) === null || _b === void 0 ? void 0 : _b.length) > 0;
    }
    get diseases() {
        var _a, _b;
        return (_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.bioMetrics) === null || _b === void 0 ? void 0 : _b.filter((bm) => bm.code_name.startsWith('SO') && bm.scoreBC.value > 0);
    }
    get numDiseases() {
        return this.diseases.length;
    }
    get metricsNoAggregated() {
        var _a, _b;
        return (_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.bioMetrics) === null || _b === void 0 ? void 0 : _b.filter((bm) => !bm.code_name.startsWith('SO'));
    }
    toggleAcreageUnits() {
        this.acreage.toggleUnits();
    }
}
exports.FieldTabular = FieldTabular;
class SampleTabular {
    constructor(obj) {
        this.name = obj.name || '',
            this.code = obj.code || '',
            this.reportVersion = obj.reportVersion || '',
            this.id = obj.id || -1,
            this.crop = obj.crop || new Crop_1.default({}),
            // this.geodata = obj.geodata || '-',
            // this.acreage = obj.acreage || new Acreage(-1, '')
            this.client = obj.client || new Client_1.default({});
        this.results = obj.results || new FarmReport({});
        this.parcel = obj.parcel || new ParcelMinimal({});
        this.addProperties();
    }
    findMetric(code) {
        return this.results.findMetric(code);
    }
    addProperties() {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.bioMetrics) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            (_d = (_c = this.results) === null || _c === void 0 ? void 0 : _c.bioMetrics) === null || _d === void 0 ? void 0 : _d.forEach((b) => {
                this[b.code_name] = b.scoreBC.value;
            });
        }
    }
    get hasMetrics() {
        var _a, _b;
        return ((_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.bioMetrics) === null || _b === void 0 ? void 0 : _b.length) > 0;
    }
    get diseases() {
        var _a, _b;
        return (_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.bioMetrics) === null || _b === void 0 ? void 0 : _b.filter((bm) => bm.code_name.startsWith('SO') && bm.scoreBC.value > 0);
    }
    get numDiseases() {
        return this.diseases.length;
    }
    get metricsNoAggregated() {
        var _a, _b;
        return (_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.bioMetrics) === null || _b === void 0 ? void 0 : _b.filter((bm) => !bm.code_name.startsWith('SO'));
    }
}
exports.SampleTabular = SampleTabular;
class FarmMinimal {
    constructor(obj) {
        this.name = obj.name || '#FarmMinimal';
        this.id = obj.id || -1;
    }
}
exports.FarmMinimal = FarmMinimal;
class ParcelMinimal {
    constructor(obj) {
        this.name = obj.name || '';
        this.geodata = obj.geodata || '',
            this.id = obj.id || -1;
    }
}
exports.ParcelMinimal = ParcelMinimal;
class TabularFieldSet {
    constructor(f) {
        this.fields = [];
        if (Array.isArray(f) && f.every((fi) => fi instanceof FieldTabular)) {
            this.fields = f;
        }
        else if (Array.isArray(f) && f.every((fi) => fi instanceof GeoEntities_2.Field)) {
            this.fields = this.parseFieldsIntoTabular(f);
        }
        else {
            this.fields = [];
        }
    }
    parseFieldsIntoTabular(fields) {
        return fields.map((f) => f.tabularize());
    }
    get totalAcreage() {
        let unit = '';
        const temp = this.fields.reduce((accum, f, i) => {
            accum += f.acreage.value;
            unit = f.acreage.unit;
            return accum;
        }, 0);
        return new Acreage_1.default(temp, unit);
    }
    get crops() {
        return Array.from(new Set(this.fields
            .map((f) => f.crop)
            .map((obj) => JSON.stringify(obj)))).map((str) => JSON.parse(str));
    }
    get cropDistribution() {
        const crops = [];
        if (this.fields.length > 0) {
            this.fields.forEach((f) => {
                const cropIx = crops.findIndex((cd) => cd.crop.id === f.crop.id);
                if (cropIx !== -1) {
                    crops[cropIx].addAcreage(f.acreage.value);
                    crops[cropIx].percentage = crops[cropIx].acreage.value / this.totalAcreage.value;
                }
                else {
                    crops.push(new GeoEntities_1.CropDistribution({
                        'crop': f.crop,
                        'acreage': f.acreage,
                        'percentage': f.acreage.value / this.totalAcreage.value
                    }));
                }
            });
        }
        return crops;
    }
    get allFields() {
        return this.fields;
    }
    get bioMetricsFarmCategories() {
        const allCategories = [];
        this.fields.forEach((f) => {
            f.results.bioMetricsByFarmCategories.forEach((afcm) => {
                const catIx = allCategories.findIndex((c) => c.name === afcm.name);
                if (catIx === -1) {
                    allCategories.push(afcm);
                }
                else {
                    allCategories[catIx].metrics.forEach((me) => {
                        const meIx = allCategories[catIx].metrics.findIndex((m) => m.code_name === me.code_name);
                        if (meIx === -1)
                            allCategories[catIx].metrics.push(me);
                    });
                }
            });
        });
        return allCategories;
    }
    get bioMetrics() {
        const categories = this.bioMetricsFarmCategories;
        const allMetrics = [];
        categories.forEach((cat) => {
            cat.metrics.forEach((me) => {
                allMetrics.push(me);
            });
        });
        return allMetrics;
    }
    get bioMetricsFarmCategoriesIgnoreAggregated() {
        const allCategories = [];
        this.fields.forEach((f) => {
            var _a;
            (_a = f.results) === null || _a === void 0 ? void 0 : _a.bioMetricsByFarmCategoriesIgnoringAggregated.forEach((afcm) => {
                const catIx = allCategories.findIndex((c) => c.name === afcm.name);
                if (catIx === -1) {
                    allCategories.push(afcm);
                }
                else {
                    allCategories[catIx].metrics
                        .forEach((me) => {
                        const meIx = allCategories[catIx].metrics.findIndex((m) => m.code_name === me.code_name);
                        if (meIx === -1)
                            allCategories[catIx].metrics.push(me);
                    });
                }
            });
        });
        return allCategories;
    }
    get bioMetricsIgnoreAggregated() {
        var _a;
        return (_a = this.bioMetrics) === null || _a === void 0 ? void 0 : _a.filter((bm) => !bm.code_name.startsWith('SO'));
    }
}
exports.TabularFieldSet = TabularFieldSet;
class TabularSampleSet {
    constructor(f) {
        this.samples = [];
        if (Array.isArray(f) && f.every((fi) => fi instanceof SampleTabular)) {
            this.samples = f;
        }
        else if (Array.isArray(f) && f.every((fi) => fi instanceof Sample_1.Sample)) {
            this.samples = this.parseFieldsIntoTabular(f);
        }
        else {
            this.samples = [];
        }
    }
    parseFieldsIntoTabular(samples) {
        return samples.map((f) => f.tabularize());
    }
    // get totalAcreage():Acreage {
    //     let unit = ''
    //     const temp = this.samples.reduce((accum:number, f:SampleTabular, i:number) => {
    //         accum += f.acreage.value;
    //         unit = f.acreage.unit
    //         return accum
    //     }, 0);
    //     return new Acreage(temp, unit)
    // }
    get crops() {
        return Array.from(new Set(this.samples
            .map((f) => f.crop)
            .map((obj) => JSON.stringify(obj)))).map((str) => JSON.parse(str));
    }
    // get cropDistribution() {
    //     const crops:CropDistribution[] = []
    //     if(this.samples.length > 0) {
    //         this.samples.forEach((f:SampleTabular) => {
    //             const cropIx = crops.findIndex((cd:CropDistribution) => cd.crop.id === f.crop.id)
    //             if(cropIx !== -1) {
    //                 crops[cropIx].addAcreage(f.acreage.value)
    //                 crops[cropIx].percentage = crops[cropIx].acreage.value / this.totalAcreage.value
    //             } else {
    //                 crops.push(new CropDistribution({
    //                     'crop': f.crop,
    //                     'acreage': f.acreage,
    //                     'percentage': f.acreage.value / this.totalAcreage.value
    //                 }))
    //             }
    //         })
    //     }
    //     return crops
    // }
    get allSamples() {
        return this.samples;
    }
    get bioMetricsFarmCategories() {
        const allCategories = [];
        this.samples.forEach((f) => {
            var _a;
            (_a = f.results) === null || _a === void 0 ? void 0 : _a.bioMetricsByFarmCategories.forEach((afcm) => {
                const catIx = allCategories.findIndex((c) => c.name === afcm.name);
                if (catIx === -1) {
                    allCategories.push(afcm);
                }
                else {
                    allCategories[catIx].metrics.forEach((me) => {
                        const meIx = allCategories[catIx].metrics.findIndex((m) => m.code_name === me.code_name);
                        if (meIx === -1)
                            allCategories[catIx].metrics.push(me);
                    });
                }
            });
        });
        return allCategories;
    }
    get bioMetrics() {
        const categories = this.bioMetricsFarmCategories;
        const allMetrics = [];
        categories.forEach((cat) => {
            cat.metrics.forEach((me) => {
                allMetrics.push(me);
            });
        });
        return allMetrics;
    }
    get bioMetricsFarmCategoriesIgnoreAggregated() {
        const allCategories = [];
        this.samples.forEach((f) => {
            var _a;
            (_a = f.results) === null || _a === void 0 ? void 0 : _a.bioMetricsByFarmCategoriesIgnoringAggregated.forEach((afcm) => {
                const catIx = allCategories.findIndex((c) => c.name === afcm.name);
                if (catIx === -1) {
                    allCategories.push(afcm);
                }
                else {
                    allCategories[catIx].metrics
                        .forEach((me) => {
                        const meIx = allCategories[catIx].metrics.findIndex((m) => m.code_name === me.code_name);
                        if (meIx === -1)
                            allCategories[catIx].metrics.push(me);
                    });
                }
            });
        });
        return allCategories;
    }
    get bioMetricsIgnoreAggregated() {
        var _a;
        return (_a = this.bioMetrics) === null || _a === void 0 ? void 0 : _a.filter((bm) => !bm.code_name.startsWith('SO'));
    }
}
exports.TabularSampleSet = TabularSampleSet;
